<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {Pagination, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import IconArrowRight from "@js/components/Icons/IconArrowRight.vue";
import {Link} from "@inertiajs/vue3";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import HomeCategoryLinks from "@js/components/Sections/Home/Components/HomeCategoryLinks.vue";


export default {
    name: "HomeTopComponent",
    components: {
        HomeCategoryLinks,
        IconAngleLeft,
        IconArrowRight,
        Swiper,
        SwiperSlide,
        Link
    },
    data() {
        return {
            swiper: null,
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
    },
    setup() {
        return {
            modules: [Pagination, Autoplay],
        };
    },
}
</script>

<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5 md:mb-8">
        <div class="group relative">
            <button v-if="swiper" @click.prevent="slidePrev" aria-label="Назад"
                    class="max-md:hidden opacity-0 group-hover:opacity-100 absolute top-1/2 -translate-y-1/2 left-2 z-10 bg-baseColor md:hover:bg-baseColor/70 text-white rounded-full w-10 h-10 flex items-center justify-center transition backdrop-blur">
                <IconAngleLeft class="w-5 h-5 text-black"/>
            </button>
            <div
                class="relative w-full aspect-w-16 aspect-h-9 aspect-[16/9]">
                <Swiper :slides-per-view="1"
                        :space-between="30"
                        @swiper="setSwiper"
                        :loop="true"
                        :modules="modules"
                        :pagination="{ clickable: true }"
                        :autoplay="{ delay: 5000, disableOnInteraction: true }"
                        class="rounded-lg overflow-hidden pagination-base long_bullet main-slider w-full h-full bg-transparent">
<!--                    <SwiperSlide>-->
<!--                        <Link :href="route('catalog', {category_title: 'plitka'})"-->
<!--                              class="flex items-center relative w-full h-full slide-bg-img-1 bg-no-repeat bg-cover bg-top md:bg-left"></Link>-->
<!--                    </SwiperSlide>-->
                    <SwiperSlide>
                        <Link :href="route('catalog', {category_title: 'plitka'})"
                              class="flex items-center relative w-full h-full slide-bg-img-4 bg-no-repeat bg-cover bg-top md:bg-right"></Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link :href="route('catalog', {category_title: 'plitka'})"
                              class="flex items-center relative w-full h-full slide-bg-img-2 bg-no-repeat bg-cover bg-top md:bg-right"></Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link :href="route('catalog', {category_title: 'plitka'})"
                              class="flex items-center relative w-full h-full slide-bg-img-8 bg-no-repeat bg-cover bg-top md:bg-right"></Link>
                    </SwiperSlide>

                    <SwiperSlide>
                        <Link :href="route('catalog', {category_title: 'plitka'})"
                              class="flex items-center relative w-full h-full slide-bg-img-3 bg-no-repeat bg-cover bg-top md:bg-right"></Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link :href="route('catalog', {category_title: 'plitka'})"
                              class="flex items-center relative w-full h-full slide-bg-img-6 bg-no-repeat bg-cover bg-top md:bg-right"></Link>
                    </SwiperSlide>
                </Swiper>
            </div>
            <button v-if="swiper" @click.prevent="slideNext" aria-label="Вперед"
                    class="max-md:hidden opacity-0 group-hover:opacity-100 absolute top-1/2 -translate-y-1/2 right-2 z-10 bg-baseColor md:hover:bg-baseColor/70 text-white rounded-full w-10 h-10 flex items-center justify-center transition backdrop-blur">
                <IconAngleLeft class="w-5 h-5 text-black rotate-180"/>
            </button>
        </div>
        <HomeCategoryLinks/>
    </div>
</template>

<style scoped lang="scss">
::v-deep(.swiper-pagination-bullet) {
    background: white !important; /* Делаем точки белыми */
    opacity: 0.6; /* Делаем их слегка прозрачными */
    transition: opacity 0.3s ease;
}

::v-deep(.swiper-pagination-bullet-active) {
    background: white !important; /* Активная точка тоже белая */
    opacity: 1; /* Делаем активную точку полностью непрозрачной */
}

//.slide-bg-img-1 {
//    background-image: url("@img/home_slider/1.webp");
//}

.slide-bg-img-2 {
    background-image: url("@img/home_slider/2.webp");
}

.slide-bg-img-3 {
    background-image: url("@img/home_slider/3.webp");
}

.slide-bg-img-4 {
    background-image: url("@img/home_slider/4.webp");
}

.slide-bg-img-6 {
    background-image: url("@img/home_slider/6.webp");
}

.slide-bg-img-7 {
    background-image: url("@img/home_slider/7.webp");
}

.slide-bg-img-8 {
    background-image: url("@img/home_slider/8.webp");
}

@media (max-width: 480px) {
    //.slide-bg-img-1 {
    //    background-image: url("@img/home_slider/1_mobile.webp");
    //}

    .slide-bg-img-2 {
        background-image: url("@img/home_slider/2_480.webp");
    }

    .slide-bg-img-3 {
        background-image: url("@img/home_slider/3_480.webp");
    }

    .slide-bg-img-4 {
        background-image: url("@img/home_slider/4_480.webp");
    }

    .slide-bg-img-6 {
        background-image: url("@img/home_slider/6_480.webp");
    }

    .slide-bg-img-7 {
        background-image: url("@img/home_slider/7_480.webp");
    }

    .slide-bg-img-8 {
        background-image: url("@img/home_slider/8_480.webp");
    }
}
</style>
